import { Badge, type BadgeVariant } from '@/components/ui/badge'
import { Banner } from '@/components/ui/banner'
import { BuyerType, buyerTypeLabels, BuyerTypeRule, type SalesLead } from '@/models/salesLead'

const BADGE_VARIANTS: Record<BuyerType, BadgeVariant> = {
  [BuyerType.RENEWAL]: 'secondary',
  [BuyerType.ACTIVATION]: 'warning',
}

const GUIDANCE: Record<BuyerType, string> = {
  [BuyerType.RENEWAL]: 'Work it as a renewal: compete on price and speed against their current insurer.',
  [BuyerType.ACTIVATION]:
    'Needs insurance before they can operate. Lead with the monthly cost and financing, not the annual premium.',
}

const REASONS: Record<BuyerTypeRule, string> = {
  [BuyerTypeRule.CURRENT_INSURER]: 'They have an insurer on file.',
  [BuyerTypeRule.AUTHORITY_ACTIVE]: 'Their operating authority is active, which requires insurance on file.',
  [BuyerTypeRule.INTRASTATE]: 'They only run within their state.',
  [BuyerTypeRule.CONFIRMED_UNINSURED]:
    'FMCSA shows them running interstate with no active authority and no insurance filings.',
  [BuyerTypeRule.DEFAULT]: 'We can’t confirm they’re uninsured.',
}

/** The lead's buyer type with how to work it. Advisory only: nothing acts on it automatically. */
export function BuyerTypeSection({ lead }: { lead: SalesLead }) {
  return (
    <div className="space-y-1.5 border-b pb-3">
      <Badge variant={BADGE_VARIANTS[lead.buyerType]}>{buyerTypeLabels[lead.buyerType]} buyer</Badge>
      <p>{GUIDANCE[lead.buyerType]}</p>
      {lead.buyerTypeRule && <p className="text-muted-foreground text-xs">{REASONS[lead.buyerTypeRule]}</p>}
      {lead.intrastateOnly && (
        <Banner variant="info" small>
          Intrastate — no federal filing on record. Ask whether they currently carry coverage.
        </Banner>
      )}
    </div>
  )
}
